module.exports = __webpack_public_path__ + "img/noComplete.e740298e.png";